import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Form, Navbar, Nav } from 'react-bootstrap';
import './DataworkerLanding.css';
import dwLogo from '../../assets/img/dataworker_logo.png';
import dwHero from '../../assets/img/dataworker_backgroundhero.jpg';
import { Routes } from '../../routes';
import { useHistory } from 'react-router';
import { parsedUser } from '../../common/GetCurrentUser';

const DataworkerLanding: React.FC = () => {
    const [scrolled, setScrolled] = useState(false);
    document.title = "DataWorker - Gestión de Controles Laborales";
    const user = parsedUser();
    const history = useHistory();

    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 10;
            setScrolled(isScrolled);
        };
        if (user) {
            history.push(Routes.Dataworkerhome.path);
        }
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="dataworker-landing">
            {/* Sticky Navigation */}
            <Navbar
                expand="lg"
                fixed="top"
                className={`custom-navbar ${scrolled ? 'scrolled' : ''}`}
            >
                <Container>
                    <Navbar.Brand href="#home" className="fw-bold fs-4 text-primary">
                        <img src={dwLogo} alt="DataWorker Logo" style={{ height: '30px', marginRight: '10px' }} />

                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="basic-navbar-nav">
                        <span className="navbar-toggler-icon"></span>
                    </Navbar.Toggle>

                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto align-items-center">
                            <Nav.Link
                                href="#services"
                                className="nav-link-custom mx-2"
                                onClick={() => scrollToSection('services')}
                            >
                                Servicios
                            </Nav.Link>
                            <Nav.Link
                                href="#workercheck"
                                className="nav-link-custom mx-2"
                                onClick={() => scrollToSection('workercheck')}
                            >
                                WorkerCheck
                            </Nav.Link>
                            <Nav.Link
                                href="#modules"
                                className="nav-link-custom mx-2"
                                onClick={() => scrollToSection('modules')}
                            >
                                Módulos
                            </Nav.Link>
                            <Nav.Link
                                href="#contact"
                                className="nav-link-custom mx-2"
                                onClick={() => scrollToSection('contact')}
                            >
                                Contacto
                            </Nav.Link>
                            <Button
                                variant="primary"
                                size="sm"
                                className="ms-3 px-3 py-2 nav-btn"
                                onClick={() => {
                                    history.push(Routes.SignIn.path);
                                }}
                            >
                                <i className="fas fa-sign-in-alt me-2"></i>
                                Ingresar
                            </Button>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            {/* Hero Section */}
            <section
                id="home"
                className="hero-section text-white py-5 mb-0"
                style={{
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), 
                    url('${dwHero}')`,
                }}
            >
                <Container className="position-relative">
                    <Row className="align-items-center min-vh-100">
                        <Col lg={10} xl={8} className="mx-auto text-center">
                            <h1 className="hero-title mb-4">
                                DataWorker
                            </h1>
                            <p className="hero-subtitle mb-4">
                                Gestión de los Controles Laborales que<br />
                                Garantizan la Seguridad Jurídica de la Empresa
                            </p>
                            <p className="hero-description mb-5">
                                Plataforma integral para la gestión y documentación de controles laborales,<br />
                                garantizando la seguridad jurídica de su empresa, proyecto o negocio con tecnología avanzada.
                            </p>
                            <div className="hero-buttons d-grid gap-3 d-md-flex justify-content-md-center">
                                <Button
                                    variant="light"
                                    size="lg"
                                    className="hero-btn-primary me-md-3 px-5 py-3"
                                    onClick={() => {
                                        history.push(Routes.SignIn.path);
                                    }}
                                >
                                    <i className="fas fa-rocket me-2"></i>
                                    Comenzar Ahora
                                </Button>
                                <Button
                                    variant="outline-light"
                                    size="lg"
                                    className="hero-btn-secondary px-5 py-3"
                                    onClick={() => scrollToSection('services')}
                                >
                                    <i className="fas fa-info-circle me-2"></i>
                                    Conocer Más
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Services Overview */}
            <section id="services" className="services-section py-5 bg-light">
                <Container>
                    <Row>
                        <Col lg={12} className="text-center mb-5">
                            <h2 className="display-2 fw-bold text-primary mb-3">
                                Nuestros Servicios
                            </h2>
                            <p className="lead text-muted">
                                Soluciones integrales para la gestión y control laboral empresarial
                            </p>
                        </Col>
                    </Row>
                    <Row className="g-4">
                        <Col md={6} lg={3}>
                            <Card className="h-100 border-0 shadow-sm service-card">
                                <Card.Body className="text-center p-4">
                                    <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{ width: '80px', height: '80px' }}>
                                        <i className="fas fa-id-card text-primary fa-2x"></i>
                                    </div>
                                    <h5 className="fw-bold mb-3">Documentar Identidad</h5>
                                    <p className="text-muted">
                                        Verificación y documentación completa de la identidad de empleados y colaboradores
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6} lg={3}>
                            <Card className="h-100 border-0 shadow-sm service-card">
                                <Card.Body className="text-center p-4">
                                    <div className="bg-danger bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{ width: '80px', height: '80px' }}>
                                        <i className="fas fa-exclamation-triangle text-danger fa-2x"></i>
                                    </div>
                                    <h5 className="fw-bold mb-3">Documentar Inconductas</h5>
                                    <p className="text-muted">
                                        Registro y seguimiento de inconductas laborales para protección empresarial
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6} lg={3}>
                            <Card className="h-100 border-0 shadow-sm service-card">
                                <Card.Body className="text-center p-4">
                                    <div className="bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{ width: '80px', height: '80px' }}>
                                        <i className="fas fa-file-contract text-warning fa-2x"></i>
                                    </div>
                                    <h5 className="fw-bold mb-3">Formalización y Notificación</h5>
                                    <p className="text-muted">
                                        Gestión formal de demandas y notificaciones con validez jurídica
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6} lg={3}>
                            <Card className="h-100 border-0 shadow-sm service-card">
                                <Card.Body className="text-center p-4">
                                    <div className="bg-info bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{ width: '80px', height: '80px' }}>
                                        <i className="fas fa-share-alt text-info fa-2x"></i>
                                    </div>
                                    <h5 className="fw-bold mb-3">Compartir con Asociaciones</h5>
                                    <p className="text-muted">
                                        Comunicación interna de inconductas que amenacen la seguridad del sector
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* WorkerCheck Section */}
            <section id="workercheck" className="workercheck-section py-5">
                <Container>
                    <Row>
                        <Col lg={12} className="text-center mb-5">
                            <h2 className="display-2 fw-bold text-primary mb-3">
                                <i className="fas fa-user-check me-3"></i>
                                WorkerCheck
                            </h2>
                            <p className="lead text-muted">
                                Verificación Integral del Historial y Aptitudes Laborales
                            </p>
                        </Col>
                    </Row>

                    <Row className="g-4 mb-5">
                        <Col lg={6}>
                            <Card className="border-0 shadow-lg h-100 workercheck-card">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="bg-primary bg-opacity-10 rounded-circle p-3 me-3">
                                            <i className="fas fa-id-badge text-primary fa-lg"></i>
                                        </div>
                                        <h4 className="fw-bold text-primary mb-0">Verificación de Identidad</h4>
                                    </div>
                                    <h6 className="text-muted mb-3">Identificación y Documentación de Personas Extranjeras</h6>

                                    <div className="validation-item mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                            <i className="fas fa-check-circle text-success me-2"></i>
                                            <span className="fw-bold text-primary">VALIDACIÓN:</span>
                                        </div>
                                        <p className="ms-4 mb-0 text-dark">Identidad y Currículo</p>
                                    </div>

                                    <div className="validation-item">
                                        <div className="d-flex align-items-center mb-2">
                                            <i className="fas fa-info-circle text-info me-2"></i>
                                            <span className="fw-bold text-primary">CONOCIMIENTO:</span>
                                        </div>
                                        <p className="ms-4 mb-0 text-dark">SI POSEE O NO Antecedentes Laborales y Judiciales</p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col lg={6}>
                            <Card className="border-0 shadow-lg h-100 workercheck-card">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="bg-warning bg-opacity-10 rounded-circle p-3 me-3">
                                            <i className="fas fa-clipboard-check text-warning fa-lg"></i>
                                        </div>
                                        <h4 className="fw-bold text-primary mb-0">Verificación de Historial</h4>
                                    </div>
                                    <h6 className="text-muted mb-3">Aptitudes Laborales y Antecedentes</h6>

                                    <div className="validation-item mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                            <i className="fas fa-check-circle text-success me-2"></i>
                                            <span className="fw-bold text-primary">VALIDACIÓN:</span>
                                        </div>
                                        <p className="ms-4 mb-1 text-dark">Identidad y Currículo</p>
                                    </div>

                                    <div className="validation-item mb-2">
                                        <div className="d-flex align-items-center mb-1">
                                            <i className="fas fa-briefcase text-primary me-2"></i>
                                            <span className="text-dark">SI POSEE O NO Antecedentes Laborales</span>
                                        </div>
                                    </div>

                                    <div className="validation-item mb-3">
                                        <div className="d-flex align-items-center mb-1">
                                            <i className="fas fa-gavel text-danger me-2"></i>
                                            <span className="text-dark">SI POSEE O NO Antecedentes Judiciales</span>
                                        </div>
                                    </div>

                                    <div className="validation-item">
                                        <div className="d-flex align-items-center mb-1">
                                            <i className="fas fa-chart-bar text-info me-2"></i>
                                            <span className="fw-bold text-primary">DATOS DEMOGRÁFICOS</span>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12} className="text-center">
                            <div className="workercheck-cta bg-primary bg-opacity-5 rounded-3 p-5">
                                <h4 className="fw-bold text-primary mb-3">
                                    <i className="fas fa-shield-alt me-2"></i>
                                    Proceso de Verificación Completo
                                </h4>
                                <p className="lead text-muted mb-4">
                                    Nuestro sistema WorkerCheck garantiza una verificación exhaustiva y confiable
                                    de todos los aspectos críticos del historial laboral y personal.
                                </p>
                                <Button
                                    variant="primary"
                                    size="lg"
                                    className="px-5 py-3"
                                    onClick={() => scrollToSection('contact')}
                                >
                                    <i className="fas fa-rocket me-2"></i>
                                    Solicitar Verificación
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Modules Section */}
            <section id="modules" className="modules-section py-5">
                <Container>
                    <Row>
                        <Col lg={12} className="text-center mb-5">
                            <h2 className="display-2 fw-bold text-primary mb-3">
                                Módulos del Sistema
                            </h2>
                            <p className="lead text-muted">
                                Herramientas especializadas para cada área de gestión laboral
                            </p>
                        </Col>
                    </Row>
                    <Row className="g-4">
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100 module-card">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-start">
                                        <div className="bg-success bg-opacity-10 rounded p-3 me-3">
                                            <i className="fas fa-door-open text-success fa-lg"></i>
                                        </div>
                                        <div>
                                            <h5 className="fw-bold mb-2">Gestión de Acceso</h5>
                                            <p className="text-muted mb-0">
                                                Control de acceso y asistencia del personal con tecnología biométrica avanzada
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100 module-card">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-start">
                                        <div className="bg-warning bg-opacity-10 rounded p-3 me-3">
                                            <i className="fas fa-bell text-warning fa-lg"></i>
                                        </div>
                                        <div>
                                            <h5 className="fw-bold mb-2">Notificaciones de Inconductas</h5>
                                            <p className="text-muted mb-0">
                                                Formalización y notificación automática de inconductas laborales
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100 module-card">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-start">
                                        <div className="bg-primary bg-opacity-10 rounded p-3 me-3">
                                            <i className="fas fa-users text-primary fa-lg"></i>
                                        </div>
                                        <div>
                                            <h5 className="fw-bold mb-2">Gestión de Plantilla</h5>
                                            <p className="text-muted mb-0">
                                                Documentación completa y gestión integral de todo el personal
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100 module-card">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-start">
                                        <div className="bg-info bg-opacity-10 rounded p-3 me-3">
                                            <i className="fas fa-fingerprint text-info fa-lg"></i>
                                        </div>
                                        <div>
                                            <h5 className="fw-bold mb-2">Datos Biométricos</h5>
                                            <p className="text-muted mb-0">
                                                Gestión segura de datos biométricos para identificación precisa
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Contact Section */}
            <section id="contact" className="contact-section py-5 bg-light">
                <Container>
                    <Row>
                        <Col lg={12} className="text-center mb-5">
                            <h2 className="display-2 fw-bold text-primary mb-3">
                                Contáctanos
                            </h2>
                            <p className="lead text-muted">
                                ¿Listo para mejorar la gestión laboral de tu empresa? Contáctanos hoy
                            </p>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <Card className="border-0 shadow">
                                <Card.Body className="p-5">
                                    <Form>
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Nombre Completo</Form.Label>
                                                    <Form.Control type="text" placeholder="Ingrese su nombre completo" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control type="email" placeholder="Ingrese su email" />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Empresa</Form.Label>
                                                    <Form.Control type="text" placeholder="Nombre de su empresa" />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Teléfono</Form.Label>
                                                    <Form.Control type="tel" placeholder="Número de teléfono" />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Form.Group className="mb-4">
                                            <Form.Label>Mensaje</Form.Label>
                                            <Form.Control as="textarea" rows={4} placeholder="Cuéntanos sobre tus necesidades de gestión laboral" />
                                        </Form.Group>
                                        <div className="text-center">
                                            <Button variant="primary" size="lg" type="submit" className="px-5">
                                                <i className="fas fa-paper-plane me-2"></i>
                                                Enviar Mensaje
                                            </Button>
                                        </div>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Footer */}
            <footer className="bg-dark text-white py-5">
                <Container>
                    <Row>
                        <Col lg={4} className="mb-4">
                            <h5 className="fw-bold mb-3">DataWorker</h5>
                            <p className="text-light opacity-75">
                                Líder en gestión de controles laborales con tecnología avanzada,
                                garantizando la seguridad jurídica empresarial.
                            </p>
                        </Col>
                        <Col lg={4} className="mb-4">
                            <h5 className="fw-bold mb-3">Módulos</h5>
                            <ul className="list-unstyled">
                                <li className="mb-2"><a href="#" className="text-light text-decoration-none opacity-75">Gestión de Acceso</a></li>
                                <li className="mb-2"><a href="#" className="text-light text-decoration-none opacity-75">Control de Asistencia</a></li>
                                <li className="mb-2"><a href="#" className="text-light text-decoration-none opacity-75">Notificaciones Laborales</a></li>
                                <li className="mb-2"><a href="#" className="text-light text-decoration-none opacity-75">Datos Biométricos</a></li>
                            </ul>
                        </Col>
                        <Col lg={4} className="mb-4 d-none">
                            <h5 className="fw-bold mb-3">Contacto</h5>
                            <ul className="list-unstyled">
                                <li className="mb-2">
                                    <i className="fas fa-phone me-2"></i>
                                    <span className="text-light opacity-75">+1 (809) 123-4567</span>
                                </li>
                                <li className="mb-2">
                                    <i className="fas fa-envelope me-2"></i>
                                    <span className="text-light opacity-75">info@dataworker.com</span>
                                </li>
                                <li className="mb-2">
                                    <i className="fas fa-map-marker-alt me-2"></i>
                                    <span className="text-light opacity-75">Santo Domingo, República Dominicana</span>
                                </li>
                            </ul>
                        </Col>
                    </Row>
                    <hr className="my-4 opacity-25" />
                    <Row>
                        <Col lg={12} className="text-center">
                            <p className="mb-0 text-light opacity-75">
                                &copy; 2025 DataWorker. Todos los derechos reservados.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </div>
    );
};

export default DataworkerLanding;